module.exports = __webpack_public_path__ + "static/media/reset.8e573cec.svg";